import { render, staticRenderFns } from "./IcoX.vue?vue&type=template&id=270fb3e4"
import script from "./IcoX.vue?vue&type=script&lang=js"
export * from "./IcoX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports